var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row justify-content-center mb-4" }, [
    _c("div", { staticClass: "col-12 mr-3 text-right" }, [
      _c(
        "a",
        {
          staticClass: "clickable text-primary small hide-tutorial",
          on: { click: _vm.disableTutorial },
        },
        [_vm._v(_vm._s(_vm.$t("dashboard.tutorial.dontShowMeThis")))]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12 text-center d-flex" },
      [
        _c(
          "b-carousel",
          {
            staticStyle: { width: "100%" },
            attrs: { interval: 0, controls: "", indicators: "" },
          },
          [
            _c(
              "b-carousel-slide",
              {
                ref: "clientProfile",
                staticClass: "p-lg-5 p-2",
                staticStyle: {
                  "background-color": "#c137a2",
                  "min-height": "320px",
                },
              },
              [
                _c("tutorial-slide", {
                  attrs: {
                    header: _vm.$t("dashboard.tutorial.headers.clientProfile"),
                    subtitle: _vm.$t(
                      "dashboard.tutorial.subtitles.welcomeBack"
                    ),
                    "button-text": _vm.$t(
                      "dashboard.tutorial.buttonTexts.clientProfile"
                    ),
                    href: "#/board?createNewClient=true",
                    "img-src": _vm.clientProfileImg,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-carousel-slide",
              {
                ref: "application",
                staticClass: "p-lg-5 p-2",
                staticStyle: {
                  "background-color": "#3141bc",
                  "min-height": "320px",
                },
              },
              [
                _c("tutorial-slide", {
                  attrs: {
                    header: _vm.$t("dashboard.tutorial.headers.application"),
                    subtitle: _vm.$t(
                      "dashboard.tutorial.subtitles.uploadDocuments"
                    ),
                    "button-text": _vm.$t(
                      "dashboard.tutorial.buttonTexts.application"
                    ),
                    href: "#/applications?addApplication=true",
                    "img-src": _vm.createAppImg,
                    direction: "left",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-carousel-slide",
              {
                ref: "customizePortal",
                staticClass: "p-lg-5 p-2",
                staticStyle: {
                  "background-color": "#0074e0",
                  "min-height": "320px",
                },
              },
              [
                _c("tutorial-slide", {
                  attrs: {
                    header: _vm.$t("dashboard.tutorial.headers.customize"),
                    subtitle: _vm.$t(
                      "dashboard.tutorial.subtitles.customization"
                    ),
                    "button-text": _vm.$t(
                      "dashboard.tutorial.buttonTexts.customize"
                    ),
                    href: "#/personal-settings/theme",
                    "img-src": _vm.portalImg,
                    direction: "left",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.isBroker
              ? _c(
                  "b-carousel-slide",
                  {
                    ref: "agents",
                    staticClass: "p-lg-5 p-2",
                    staticStyle: {
                      "background-color": "#cb07cf",
                      "min-height": "320px",
                    },
                  },
                  [
                    _c("tutorial-slide", {
                      attrs: {
                        header: _vm.$t("dashboard.tutorial.headers.agents"),
                        subtitle: _vm.$t(
                          "dashboard.tutorial.subtitles.emailNotifications"
                        ),
                        "button-text": _vm.$t(
                          "dashboard.tutorial.buttonTexts.agents"
                        ),
                        href: "#/agents?addAgent=true",
                        "img-src": _vm.addAgentImg,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-carousel-slide",
              {
                ref: "profile",
                staticClass: "p-lg-5 p-2",
                staticStyle: {
                  "background-color": "#12821f",
                  "min-height": "320px",
                },
              },
              [
                _c("tutorial-slide", {
                  attrs: {
                    header: _vm.$t("dashboard.tutorial.headers.profile"),
                    subtitle: _vm.$t(
                      "dashboard.tutorial.subtitles.preferences"
                    ),
                    "button-text": _vm.$t(
                      "dashboard.tutorial.buttonTexts.profile"
                    ),
                    href: "#/personal-settings",
                    "img-src": _vm.editProfileImg,
                    direction: "left",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-carousel-slide",
              {
                ref: "filogixImport",
                staticClass: "p-lg-5 p-2",
                staticStyle: {
                  "background-color": "#0074e0",
                  "min-height": "320px",
                },
              },
              [
                _c("tutorial-slide", {
                  attrs: {
                    header: _vm.$t("dashboard.tutorial.headers.import"),
                    subtitle: _vm.$t(
                      "dashboard.tutorial.subtitles.filogixImport"
                    ),
                    "button-text": _vm.$t(
                      "dashboard.tutorial.buttonTexts.import"
                    ),
                    href: "#/clients/applications?importClients=true",
                    "img-src": _vm.filogixImg,
                    direction: "left",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-carousel-slide",
              {
                ref: "finish",
                staticClass: "p-lg-5 p-2",
                staticStyle: {
                  "background-color": "#c137a2",
                  "min-height": "320px",
                },
              },
              [
                _c("tutorial-slide", {
                  attrs: {
                    header: _vm.$t("dashboard.tutorial.headers.allSetUp"),
                    subtitle: _vm.$t("dashboard.tutorial.subtitles.allSetUp"),
                    "img-src": _vm.finishImg,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }